import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useRef, useState } from "react";
import Slider from "@mui/material/Slider";

export default function App() {
  const [active, setActive] = useState("Hit a key to play");
  const [slider, setSlider] = useState(75);
  const [power, setPower] = useState(true);

  const keys = [
    {
      name: "Q",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3",
      audio: "Guitar Variant 1",
    },
    {
      name: "W",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3",
      audio: "Guitar Variant 2",
    },
    {
      name: "E",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3",
      audio: "Guitar Variant 3",
    },
    {
      name: "A",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3",
      audio: "Guitar Variant 4",
    },
    {
      name: "S",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3",
      audio: "Clap",
    },
    {
      name: "D",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3",
      audio: "Closed Hi-Hat",
    },
    {
      name: "Z",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3",
      audio: "Kick & Hat",
    },
    {
      name: "X",
      src: "https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3",
      audio: "Kick",
    },
    {
      name: "C",
      src: "https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3",
      audio: "Hi-Hat",
    },
  ];

  const playAudio = (e) => {
    const sound = e.target.querySelector("audio");
    // sound.currentTime = 0;
    sound.volume = slider / 100;

    const soundName = sound.getAttribute("name");
    document.getElementById("display").innerText = soundName;
    sound.play();
  };

  const playFromKey = (e) => {
    let sound;
    for (let key in keys) {
      if (keys[key].name === e.key.toUpperCase()) {
        sound = document.getElementById(keys[key].name).querySelector("audio");
      }
    }
    if (!power) {
      sound.volume = 0;
      document.getElementById("display").innerText = 'Hit a key to play';
    } else {
      sound.volume = typeof (slider / 100) ? slider / 100 : slider;
      const soundName = sound.getAttribute("name");
      document.getElementById("display").innerText = soundName;
    }
    // sound.currentTime = 0
    sound.play();
    
  };

  document.addEventListener("keydown", playFromKey);

  const sliderRef = useRef();

  useEffect(() => {
    sliderRef?.current?.addEventListener("click", (e) => {
      setSlider(e.target.children[1].style.width.slice(0, 2));
    });
  }, []);

  const powerStyles = () => {
    if (power) {
      return { backgroundColor: "#ea0046" };
    } else {
      return { border: "1px solid #ea0046" };
    }
  };

  return (
    <div className="App d-flex justify-content-center align-items-center">
      <div
        id="drum-machine"
        className="container d-flex h-50 w-50"
        style={{
          border: "solid 1px grey",
          borderRadius: "5px",
          boxShadow: "#494949 2px 2px 50px",
        }}
      >
        <div
          id="drum-pad"
          className="container d-flex col-6 flex-wrap align-items-center py-3 ps-4"
        >
          {keys.map((key) => {
            return (
              <button
                key={key.audio}
                id={key.name}
                disabled={!power}
                onClick={(e) => playAudio(e)}
                className="drum-pad d-flex justify-content-center align-items-center me-4 my-1"
              >
                <audio
                  id={key.name}
                  name={key.audio}
                  className="clip"
                  data-multiple
                  src={key.src}
                ></audio>
                {key.name}
              </button>
            );
          })}
        </div>

        <div className="col-6 d-flex flex-column justify-content-center align-items-center text-center">
          <p id="display">{active}</p>
          <div style={{ width: "100%", marginBottom: "2em" }}>
            <Slider
              defaultValue={75}
              style={{ width: "40%", color: "white" }}
              size="small"
              ref={sliderRef}
              aria-label="Default"
              valueLabelDisplay="auto"
            />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => setPower(!power)}
            id="power"
            style={powerStyles()}
          >
            <p style={{ margin: "0", fontSize: "0.7em" }}>
              I/O: {power ? "On" : "Off"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
